import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AppError {
  message: string;
  code?: string;
  timestamp: Date;
  context?: string;
  details?: unknown;
}

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private errors$ = new BehaviorSubject<AppError[]>([]);
  private lastError$ = new BehaviorSubject<AppError | null>(null);

  get errors(): Observable<AppError[]> {
    return this.errors$.asObservable();
  }

  get lastError(): Observable<AppError | null> {
    return this.lastError$.asObservable();
  }

  handleError(
    message: string,
    options?: { code?: string; context?: string; details?: unknown },
  ): void {
    const error: AppError = {
      message,
      code: options?.code,
      timestamp: new Date(),
      context: options?.context,
      details: options?.details,
    };

    this.lastError$.next(error);
    this.errors$.next([...this.errors$.value, error]);

    console.error(
      `[ErrorService] ${options?.context || 'Error'}:`,
      message,
      options?.details,
    );
  }

  clearErrors(): void {
    this.errors$.next([]);
    this.lastError$.next(null);
  }

  clearLastError(): void {
    this.lastError$.next(null);
  }

  logError(object: any) {
    // TODO - send to analytics
  }
}
